import React from "react";
import underlineimage from "../assets/images/title-shape.png";
import friendinvite from "../assets/images/refer-friend-left-img.png";
import frnbbg from "../assets/images/refer-friend-bg.jpg"; //  background image
import { useTranslation } from "react-i18next";
const TelecomIntegration: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div
      className="text-center py-16 px-4 md:px-10 lg:px-20 bg-no-repeat bg-center bg-cover overflow-hidden"
      style={{
        backgroundImage: `url(${frnbbg})`,
      }}
    >
      {/* Section Title */}
      <h2 className="text-[36px] md:text-[48px] font-oswald font-extrabold text-[#070B28]">
        {t("telecomint")}
      </h2>

      {/* Underline image */}
      <img
        src={underlineimage}
        alt="underline"
        className="mx-auto mt-2 mb-6 w-[120px] h-auto"
      />

      {/* Tagline */}
      {/* <p className="text-[16px] md:text-[18px] font-proxima font-medium text-[#070B28] leading-relaxed mb-11">
        Daily tournaments for your favourite games. Build your stats & win exciting prizes!
      </p> */}

      {/* Content: Image Left, Text Right */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-10 md:gap-20 max-w-6xl mx-auto">
        {/* Left: Image */}
        <div className="w-full md:w-1/2 flex justify-center px-2 md:px-0">
          <img
            src={friendinvite}
            alt="Invite a Friend"
            className="w-full max-w-[350px] md:max-w-[400px] h-auto"
          />
        </div>

        {/* Right: Text */}
        <div className="w-full md:w-1/2 text-center md:text-left px-2 md:px-0">
          <p className="text-[18px] md:text-[22px] font-proxima font-semibold text-[#070B28] max-w-xl mx-auto md:mx-0">
            {t("gamerjiprovideplugandplay")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TelecomIntegration;
